import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import Employment from 'features/application/screens/Employment/Employment';
import useReactivationPrefillData from 'features/reactivation/hooks/useReactivationPrefillData';
import React from 'react';
import { useTranslation } from 'react-i18next';

const EmploymentWrapper = () => {
  const {
    reactivationApplicationId,
    prefillDataError,
    prefillDataFetching,
    refetch: refetchPrefillData,
  } = useReactivationPrefillData();

  const { t } = useTranslation('signup', {
    keyPrefix: 'employment',
  });

  return (
    <Employment
      applicationId={reactivationApplicationId}
      nextRoute="/reactivation/review-info"
      sourceName={SourceName.REACTIVATION_EMPLOYMENT}
      error={prefillDataError as Error}
      isReapplication={false}
      hasApplicationLoaded={!!reactivationApplicationId}
      onRetry={refetchPrefillData}
      backRoute="/reactivation/review-info"
      title={t('title')}
      description={t('description')}
      analyticsStepName="personal_info_employment"
      isReactivation
      applicationDataLoading={prefillDataFetching}
    />
  );
};

export default EmploymentWrapper;
